
export const colors = [
  ["#123262", "#406595", "#4065C5", "#123293", "#000093", "#0000C4", "#000061"],
  [
    "#2B6465",
    "#2B6495",
    "#4397C7",
    "#2B64C5",
    "#1232C4",
    "#0000F5",
    "#3333F5",
    "#333393",
  ],
  [
    "#719898",
    "#439798",
    "#67C9CB",
    "#5CC9FA",
    "#4397F7",
    "#2B64F6",
    "#4065F6",
    "#3333C4",
    "#480EC4",
  ],
  [
    "#52976A",
    "#5CC99C",
    "#75FBCF",
    "#75FBFD",
    "#67C9FA",
    "#5297F7",
    "#7198F8",
    "#6666F6",
    "#5D0EF5",
    "#5D0EC4",
  ],
  [
    "#529742",
    "#5CC971",
    "#75FBA2",
    "#92FCCF",
    "#92FCFD",
    "#80CAFA",
    "#A4CBFA",
    "#9999F8",
    "#9268F6",
    "#8D3AF6",
    "#8C1AF5",
  ],
  [
    "#2B6419",
    "#5CC93B",
    "#75FB4C",
    "#92FCA3",
    "#B1FCD0",
    "#D6FEFE",
    "#CCCCFB",
    "#C49BF9",
    "#BF6BF7",
    "#BC40F6",
    "#BB27F6",
    "#8C1AC5",
  ],
  [
    "#123208",
    "#439741",
    "#67C94D",
    "#92FC7A",
    "#B1FCA3",
    "#D6FED0",
    "#FFFFFF",
    "#F7CEFC",
    "#F19EF9",
    "#ED70F8",
    "#EA33F7",
    "#BB27C5",
    "#5D0E62",
  ],
  [
    "#40651A",
    "#43972A",
    "#92FC5B",
    "#B1FC7B",
    "#D6FEA4",
    "#FFFFD1",
    "#F7CECD",
    "#F19ECA",
    "#ED70C8",
    "#EB48C7",
    "#BB2795",
    "#8D3A94",
  ],
  [
    "#5E7729",
    "#71982C",
    "#B1FC5C",
    "#D6FE7D",
    "#FFFFA6",
    "#F7CEA0",
    "#F19E9C",
    "#ED7099",
    "#EB4897",
    "#BC4096",
    "#8C1A94",
  ],
  [
    "#66663A",
    "#A4CB3F",
    "#D6FE5E",
    "#FFFF7F",
    "#F7CE76",
    "#F19E70",
    "#ED706B",
    "#EA3368",
    "#CC3071",
    "#8D3A65",
  ],
  [
    "#A58C4E",
    "#CCCC42",
    "#FFFF54",
    "#F7CE46",
    "#F19E4B",
    "#ED702D",
    "#EC5E57",
    "#BB2765",
    "#5D0E32",
  ],
  [
    "#92683C",
    "#C49B33",
    "#F19E38",
    "#FF7236",
    "#EB4826",
    "#EA3323",
    "#BB271A",
    "#8C1A35",
  ],
  ["#5F360F", "#926821", "#BC401E", "#8D3A16", "#8C1A10", "#75140C", "#8D3A37"],
];

const toHexString = (num: number) => num.toString(16).padStart(2, "0");

export const convertRGBToHEX = ({
  r,
  g,
  b,
  a = 100,
}: {
  r: number;
  g: number;
  b: number;
  a?: number;
}) => {
  const hexColor = `#${toHexString(r)}${toHexString(g)}${toHexString(b)}`;

  if (a === 100) {
    return hexColor;
  }

  const alpha = Math.round((a / 100) * 255);
  return `${hexColor}${toHexString(alpha)}`;
};

export const hex_to_rgb = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};
